(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .controller('ProfileCriterionDeleteController',ProfileCriterionDeleteController);

    ProfileCriterionDeleteController.$inject = ['$uibModalInstance', 'entity', 'ProfileCriterion'];

    function ProfileCriterionDeleteController($uibModalInstance, entity, ProfileCriterion) {
        var vm = this;

        vm.profileCriterion = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ProfileCriterion.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
